import React, { createContext, useState, useCallback } from 'react';
import axios from 'axios';

export const TarotContext = createContext();

export const TarotProvider = ({ children }) => {
  const [question, setQuestion] = useState('');
  const [selectedCard, setSelectedCard] = useState(null);
  const [reading, setReading] = useState(null);
  const [remainingReadings, setRemainingReadings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRemainingReadings = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/readings/remaining`);
      setRemainingReadings(response.data.remaining);
      return response.data;
    } catch (error) {
      console.error('Error fetching remaining readings:', error);
      return { remaining: 0 };
    }
  }, []);

  const getReading = useCallback(async (question, cardId) => {
    setLoading(true);
    setError(null);
    try {
      const requestData = {
        question,
        card_id: parseInt(cardId, 10)
      };
      console.log('Sending reading request:', requestData);
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/readings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to get reading');
      }

      const data = await response.json();
      setReading(data);
      await fetchRemainingReadings();
    } catch (error) {
      console.error('Error getting reading:', error);
      setError('Failed to get reading. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [fetchRemainingReadings]);

  const clearReadingState = useCallback(() => {
    setQuestion('');
    setReading(null);
    setError(null);
    setSelectedCard(null);
  }, []);

  return (
    <TarotContext.Provider
      value={{
        question,
        setQuestion,
        selectedCard,
        setSelectedCard,
        reading,
        setReading,
        remainingReadings,
        fetchRemainingReadings,
        getReading,
        loading,
        error,
        clearReadingState
      }}
    >
      {children}
    </TarotContext.Provider>
  );
}; 